import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { MediaLibrary } from '../../models/mediaLibrary/media-library-model';
import { Observable } from 'rxjs/Observable';
import { Router } from "@angular/router";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class MediaLibraryService {
  constructor(private http: Http, private readonly router: Router, private cookieService: CookieService) { }
  private serviceName = 'api/MediaLibrary';
  getMediaLibrary() {
    return this.http.get(`${this.serviceName}/GetAllMediaLibraries`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getMediaLibraryFor(ImageFor: string) {
    return this.http.get(`${this.serviceName}/GetMediaLibraryFor?ImageFor=` + ImageFor, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  //getMediaLibrary(id: number) {
  //  return this.http.get(`${this.serviceName}/GetMediaLibraries?id=` + id)
  //    .map((response: Response) => response.json())
  //    .catch(this.errorHandler);
  //}
  updateMediaLibrary(model: MediaLibrary) {
    return this.http.post(`${this.serviceName}/UpdateMediaImage`, model, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  deleteMediaLibrary(id: string) {
    return this.http.get(`${this.serviceName}/DeleteMediaImage?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getMediaLibraryById(mediaLibraryId: string) {
    return this.http.get(`${this.serviceName}/GetImageInfoById?id=` + mediaLibraryId, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/mediaLibrary/media-library.service.ts